import { DateOnly } from '@if/core/date'
import { ProductBalanceDto } from '@src/api/loan/loan-dto'
import { EProduct } from '@src/types/constants'
import { getOperationAt, OperationInformation } from '@src/types/loan/loan-operation'

/**
 * The product balances once every operation dated on or before `date` has run: the ones the
 * backend applies a refund dated that day against. Null while no operation precedes the date.
 */
export const getProductBalancesAt = (
  operationInformations: OperationInformation[],
  date: DateOnly,
): ProductBalanceDto[] | null => getOperationAt(operationInformations, date)?.operationResultDto.productBalances ?? null

/** A product's balance in a snapshot; a product the snapshot does not carry has nothing left. */
export const getProductBalance = (balances: ProductBalanceDto[], productId: EProduct): number =>
  balances.find((balance) => balance.productId === productId)?.balance ?? 0
